// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import brandDeterminationActions from '../../actions/brandDetermination';
import BrandDetermination from './BrandDetermination';
import confirmBrandActions from '../../actions/confirmBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),

        enableContinueButton: get(state, 'brandDetermination.enableContinueButton', false),
        enableBackButton: get(state, 'brandDetermination.enableBackButton', true),
        serviceError: get(state, 'brandDetermination.serviceError', ''),

        currencyList: get(state, 'brandDetermination.currencyList', []),
        currency: get(state, 'brandDetermination.currency', ''),
        currencyError: get(state, 'brandDetermination.currencyError', ''),

        primarySite: get(state, 'brandDetermination.primarySite', {}),
        primarySiteError: get(state, 'brandDetermination.primarySiteError', ''),
        supportedCurrenciesAndSites: get(state, 'brandDetermination.supportedCurrenciesAndSites', {}),
        siteName: get(state, 'system.siteName', ''),

        dyff: get(state,'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        brandDeterminationActions: bindActionCreators(brandDeterminationActions, dispatch),
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class BrandDeterminationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handlePrimarySiteChange = this.handlePrimarySiteChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.toggleCurrencyError = this.toggleCurrencyError.bind(this);
        this.togglePrimarySiteError = this.togglePrimarySiteError.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentWillMount() {
        if (isEmpty(this.props.supportedCurrenciesAndSites)) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.brandDeterminationActions.getSupportedSites();
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Brand Determination Page');
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Brand Determination Page submit'
        }, {});

        this.props.confirmBrandActions.confirmBrand(this.props.primarySite);
        this.props.appActions.changeAppState('CONFIRM_BRAND');
    }

    handleCurrencyChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.props.brandDeterminationActions.handleFieldValueChange(event.target.id, event.target.value);

        this.props.brandDeterminationActions.toggleContinueButton();

        this.toggleCurrencyError(event);
    }

    toggleCurrencyError(event) {
        if (!event.target.value.trim()) {
            this.props.brandDeterminationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else {
            this.props.brandDeterminationActions.setFieldError(event.target.id, '');
        }
    }

    handlePrimarySiteChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Primary Site selected',
            highfrequency: 'true'
        }, {});
        if (!event.target.value) {
            this.props.brandDeterminationActions.handleFieldValueChange(event.target.id, {});
        } else {
            const sitesForCurrency = this.props.supportedCurrenciesAndSites[this.props.currency] || [];
            const primarySite = sitesForCurrency.find(site => site.name === event.target.value) || {};
            this.props.brandDeterminationActions.handleFieldValueChange(event.target.id, primarySite);
        }
        this.togglePrimarySiteError(event);
        this.props.brandDeterminationActions.toggleContinueButton(); 
    }

    togglePrimarySiteError(event) {
        if (!event.target.value) {
            this.props.brandDeterminationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else {
            this.props.brandDeterminationActions.setFieldError(event.target.id, '');
        }
    }

    handleAlertDismiss() {
        this.props.brandDeterminationActions.dismissAlertBox();
    }

    handleBackButtonClick(event) {
        const languageCurrencyMismatchFlag = this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH;
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });

        if (this.props.userType === 'PPM') {
            if (!languageCurrencyMismatchFlag) {
                // NOTE: only route back to MULTIPLE_ACCOUNTS if dyff flag is off, otherwise stay on brand determination page
                this.props.appActions.changeAppState('MULTIPLE_ACCOUNTS');
            }
            return;
        }
        // For IPM Users clear session and redirect back to intro
        window.location = '/p/onboard'
    }

    render() {
        return (<div>
            <BrandDetermination
                translations={this.props.translations}

                handlePrimarySiteOnBlur={this.togglePrimarySiteError}

                supportedCurrenciesAndSites={this.props.supportedCurrenciesAndSites}
                currencyList={this.props.currencyList}
                currency={this.props.currency}
                handleCurrencyChange={this.handleCurrencyChange}
                handlePrimarySiteChange={this.handlePrimarySiteChange}
                primarySite={this.props.primarySite}
                primarySiteError={this.props.primarySiteError}
                currencyError={this.props.currencyError}
                handleCurrencyOnBlur={this.toggleCurrencyError}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                enableBackButton={this.props.enableBackButton}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleBackButtonClick={this.handleBackButtonClick}
            />
        </div>);
    }
}

BrandDeterminationContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    companyName: PropTypes.string,
    currency: PropTypes.string,
    currencyError: PropTypes.string,
    primarySite: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    supportedCurrenciesAndSites: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    primarySiteError: PropTypes.string,
    siteName: PropTypes.string,
    userType: PropTypes.string,
};

BrandDeterminationContainer.defaultProps = {
    publicUuid: '-1',
    supportedCurrenciesAndSites: {},
    currencyList: [],
    bankingCountryList: [],
    enableContinueButton: false,
    serviceError: '',
    currency: '',
    currencyError: '',
    companyName: '',
    enableBackButton: true,
    primarySite: {},
    primarySiteError: '',
    siteName: '',
    userType: 'IPM'
};

export default BrandDeterminationContainer;
